import {Button, Dropdown, Icon, Text} from '@/components/atoms'
import {usePromotion} from '@/context/Promotion/PromotionContext'
import {DiscountReward, PromotionCondition} from '@/types/promotion'
import {COLOR_CODE} from '@/utils/constants/colors'
import {Constants} from '@/utils/constants/commonConstants'
import {RewardTypes} from '@/utils/constants/promotionConstants'
import {FC} from 'react'
import {RewardDiscount} from './RewardDiscount'
import {RewardFreeProducts} from './RewardFreeProducts'
import {RewardGiftItem} from './RewardGiftItem'
import {RewardPoints} from './RewardPoints'

export type RewardItemProps = {
  promotionCondition: PromotionCondition
}

export const RewardItem: FC<RewardItemProps> = ({promotionCondition}) => {
  const {updateCondition, promotion, setMaxDiscountModalVisible, onResultChange, promotionConfig} = usePromotion()
  const {maxDiscountPercentage, conditions} = promotionConfig

  const rewardOptions = conditions?.rewardTypeOptions?.map(option => ({
    displayText: option,
    id: option.toLocaleUpperCase().replace(' ', '_'),
  }))

  const handleDeleteLayer = sequence => {
    const updatedConditions = promotion?.promotionConditions?.filter(condition => condition.sequence !== sequence)
    onResultChange({promotionConditions: updatedConditions})
  }

  const handleSelectedRewardItem = value => {
    updateCondition({
      ...promotionCondition,
      rewards: [
        {
          type: value?.[0]?.id,
          items: [],
        },
      ],
    })
  }

  const rewardType = promotionCondition?.rewards?.[0]?.type
  const isRewardTypeDiscount = rewardType === RewardTypes.DISCOUNT

  const discountPercentage = (promotionCondition?.rewards?.[0] as DiscountReward)?.discountValue || ''

  const isDiscountPerGthMxdiscount = discountPercentage > maxDiscountPercentage

  const rewardValue = rewardOptions?.filter(item => item.id === rewardType)

  const getRewardType = () => {
    switch (rewardType) {
      case RewardTypes.FREE_PRODUCT:
        return <RewardFreeProducts promotionCondition={promotionCondition} />
      case RewardTypes.DISCOUNT:
        return <RewardDiscount promotionCondition={promotionCondition} showDynamicPlaceholder />
      case RewardTypes.GIFT_ITEM:
        return <RewardGiftItem promotionCondition={promotionCondition} />
      case RewardTypes.POINTS:
        return <RewardPoints promotionCondition={promotionCondition} />
      default:
        return null
    }
  }

  const renderRewardType = () => {
    const rewardType = getRewardType()

    if (rewardType) {
      return (
        <>
          <Text>{','}</Text>
          {rewardType}
        </>
      )
    } else {
      return null
    }
  }

  return (
    <>
      <Dropdown
        isJsonWrap={false}
        childList={rewardOptions}
        placeholder={Constants.Select}
        updateValue={handleSelectedRewardItem}
        isClearable={false}
        value={rewardValue}
        autocomplete="off"
        required={true}
      />
      {renderRewardType()}
      {promotionCondition?.sequence > 1 && (
        <Button
          uiSchema={{
            variant: 'tertiary',
            title: 'Delete layer',
            isDark: true,
            size: 'small',
            className: '',
            isLoading: false,
          }}
          handleButton={() => handleDeleteLayer(promotionCondition?.sequence)}
        />
      )}

      {isRewardTypeDiscount && isDiscountPerGthMxdiscount && (
        <>
          <Text style={{color: COLOR_CODE._D0D0D0, display: 'flex', gap: 3, alignItems: 'center'}} size="small">
            <Icon alt="alt value" icon="info" size="small" />
            Discount % exceeds max
          </Text>
          <Button
            handleButton={() => {
              setMaxDiscountModalVisible(true)
            }}
            uiSchema={{
              className: '',
              size: 'small',
              title: 'Edit Max',
              variant: 'tertiary',
              isLoading: false,
              isDark: true,
              iconLeading: 'mode_edit',
            }}
          />
        </>
      )}
    </>
  )
}
